/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */

import React from "react";
import { StoryWrapper } from "../story-wrapper";

export const ListicleStory = props => {
  return <StoryWrapper {...props} />;
};

ListicleStory.defaultProps = {
  storyStoreField: "story",
  storyPageType: "listicle-story"
};
export default ListicleStory;
